// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9ca2ce8e","239":"4eda20e6","455":"f024fadb"}[chunkId] + ".chunk.js";
};